
import { onMounted, nextTick, watch, ref, computed } from 'vue'
import store from '@/store/index'
import QuestionTileVue from './QuestionTile.vue'
export default {
  name: 'DotQueTile',
  props: {
    questionData: {
      type: Object,
      default: () => ({})
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    curTime: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const refQueTileWrap = ref(null)
    const queTypeDes = ref(props.questionData?.logicQuesTypeName || '')
    const total = ref(0)
    const isDecidable = ref(true)
    const currentTime = computed(() => {
      return props.curTime
    })
    watch(currentTime, (val) => {
      renderQuestion()
    })
    onMounted(() => {
      renderQuestion()
    })
    // 渲染题目信息
    const renderQuestion = () => {
      let data = props.questionData;
      console.log(data, '题目信息')
      // let questionIndex = props.questionIndex;
      nextTick(() => {
        window?.['TalqsInteraction']?.setUserConfig(store.getters.talqsInteractionConfig);
        // let questionTitleDom: any = document.getElementById(`questionTitle_${props.questionIndex}`);
        let questionTitleDom: any = refQueTileWrap.value;
        try {
          questionTitleDom.innerHTML = (window as any).TalqsTemplate.render(data, {
            hideDifficulty: true,
            hideSource: true,
            hideCamera: true,
          });
          (window as any).MathJax.Hub.Queue(['Typeset', (window as any).MathJax.Hub, questionTitleDom]);
          window['TalqsInteraction'].initTqiQs();
        } catch (e) {
          console.log('error', e);
        }
      });
    }
    return {
      queTypeDes,
      total,
      isDecidable,
      refQueTileWrap
    }
  }
}
